import { HelpOutline } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

const SERVICE_DESK_PORTAL_ID = 13;

const ServiceDeskLink = () => {
  return (
    <Tooltip title='Open Support Portal'>
      <a
        href={`https://insight2profit.atlassian.net/servicedesk/customer/portal/${SERVICE_DESK_PORTAL_ID}`}
        target='_blank'
        rel='noreferrer noopener'
      >
        <IconButton>
          <HelpOutline sx={{ color: 'white' }} />
        </IconButton>
      </a>
    </Tooltip>
  );
};

export default ServiceDeskLink;
